export default {
  zh: {
    plate: {
      title: '区域管理',
      btn: {
        backHome: '回到首页',
        add: '添加区域',
        addPrediction: '添加预测',
        edit: '编辑',
        delete: '删除',
        cancel: '取消',
        confirm: '确定',
        search: '查询',
        reset: '重置',
        export: '一键导出',
      },
      table: {
        plId: '区域ID',
        plCode: '区域代码',
        plName: '区域名称',
        plShowNotHappenRange: '时间范围(天)',
        plShowNotHappenOnRange: '时间范围内未发生',
        plShowNotHappenOutRange: '时间范围外未发生',
        operation: '操作',
        show: '显示',
        hide: '隐藏'
      },
      form: {
        addTitle: '添加区域',
        editTitle: '编辑区域',
        plCode: '区域代码',
        plName: '区域名称',
        plRegion: '区域范围',
        drawPlate: '绘制区域',
        drawnCount: '已绘制 {n} 个顶点',
        notDrawn: '未绘制',
        plShowNotHappenRange: '时间范围(天)',
        plShowNotHappenOnRange: '时间范围内未发生',
        plShowNotHappenOutRange: '时间范围外未发生',
        plCodePlaceholder: '请输入区域代码',
        plNamePlaceholder: '请输入区域名称',
        rangePlaceholder: '请输入天数',
        show: '显示',
        mapPickTitle: '选择位置',
        mapPickTip: '请在地图上点击选择位置',
        drawnRegions: '已绘制 {n} 个区域',
        hide: '隐藏'
      },
      draw: {
        title: '绘制区域范围',
        titleEdit: '编辑区域范围 - {name}',
        titleDraw: '绘制区域范围 - {name}',
        finish: '完成绘制',
        editMode: '编辑范围',
        exitEdit: '退出编辑',
        clear: '清除范围',
        resetView: '重置视角',
        cancel: '取消',
        save: '保存区域范围',
        statusDrawing: '绘制中',
        statusEditing: '编辑中',
        statusDrawn: '已绘制',
        statusNotDrawn: '未绘制',
        tipDrawing: '请在地图上点击添加顶点，点击"完成绘制"结束',
        tipLoaded: '已加载保存的范围，点击"编辑范围"可修改',
        tipAdded: '已添加 {n} 个顶点，继续点击添加',
        tipFinished: '绘制完成，点击"保存区域范围"保存',
        tipEditing: '编辑模式：拖动顶点调整多边形形状',
        tipExitedEdit: '已退出编辑模式',
        finishCurrent: '完成当前区域',
        newRegion: '新建区域',
        clearAll: '清除所有区域',
        regionLabel: '区域 {n}',
        tipRestored: '已恢复原始范围'
      },
      msg: {
        loadFail: '加载数据失败，请稍后重试',
        addSuccess: '新增成功',
        addFail: '新增失败',
        editSuccess: '修改成功',
        editFail: '修改失败',
        deleteSuccess: '删除成功',
        deleteFail: '删除失败，请稍后重试',
        deleteConfirm: '确定删除区域"{name}"吗？',
        tip: '提示',
        confirmDelete: '确定删除',
        cancel: '取消',
        drawMinPoints: '至少需要3个点才能形成多边形',
        drawFinished: '绘制完成，共 {n} 个顶点',
        drawFirst: '请先绘制区域范围',
        drawFirstMin: '请先绘制区域范围（至少3个点）',
        clearConfirm: '确定清除当前绘制的区域范围吗？',
        confirmClear: '确定清除',
        cleared: '已清除当前绘制，可以重新绘制',
        saved: '区域范围已保存',
        saveFail: '保存失败，请稍后重试',
        exportEmpty: '当前数据为空，无需导出',
        exportSuccess: '导出成功',
        exportFail: '导出失败，请重试',
        removeRegionConfirm: '确定删除该区域吗？',
        finishCurrentFirst: '请先完成当前区域的绘制',
        cross180NotSupported: '不支持跨越 180° 经线绘制，请分段绘制。',
        scriptNotLoaded: '地图脚本未加载，请稍后重试'
      },
      validate: {
        plCodeRequired: '请输入区域代码',
        plCodeMax: '区域代码不能超过50个字符',
        plNameRequired: '请输入区域名称',
        plNameMax: '区域名称不能超过100个字符',
        rangeRequired: '请输入时间范围',
        rangeBetween: '时间范围应在0-365之间',
        onRangeRequired: '请选择时间范围内未发生预测是否显示',
        outRangeRequired: '请选择时间范围外未发生预测是否显示'
      }
    }
  },
  en: {
    plate: {
      title: 'Region Management',
      btn: {
        backHome: 'Back to Home',
        add: 'Add Region',
        addPrediction: 'Add Prediction',
        edit: 'Edit',
        delete: 'Delete',
        cancel: 'Cancel',
        confirm: 'Confirm',
        search: 'Search',
        reset: 'Reset',
        export: 'Export All',
      },
      table: {
        plId: 'Region ID',
        plCode: 'Region Code',
        plName: 'Region Name',
        plShowNotHappenRange: 'Time Range (days)',
        plShowNotHappenOnRange: 'In-Range Not Occurred',
        plShowNotHappenOutRange: 'Out-of-Range Not Occurred',
        operation: 'Actions',
        show: 'Show',
        hide: 'Hide'
      },
      form: {
        addTitle: 'Add Region',
        editTitle: 'Edit Region',
        plCode: 'Region Code',
        plName: 'Region Name',
        plRegion: 'Region Area',
        drawPlate: 'Draw Region',
        drawnCount: '{n} vertices drawn',
        notDrawn: 'Not Drawn',
        plShowNotHappenRange: 'Time Range (days)',
        plShowNotHappenOnRange: 'Not Occurred In Range',
        plShowNotHappenOutRange: 'Not Occurred Out of Range',
        plCodePlaceholder: 'Enter region code',
        plNamePlaceholder: 'Enter region name',
        rangePlaceholder: 'Enter days',
        show: 'Show',
        mapPickTitle: 'Pick Location',
        mapPickTip: 'Click on the map to pick a location',
        drawnRegions: '{n} region(s) drawn',
        hide: 'Hide'
      },
      draw: {
        title: 'Draw Region Area',
        titleEdit: 'Edit Region Area - {name}',
        titleDraw: 'Draw Region Area - {name}',
        finish: 'Finish',
        editMode: 'Edit Region',
        exitEdit: 'Exit Edit',
        clear: 'Clear Region',
        resetView: 'Reset View',
        cancel: 'Cancel',
        save: 'Save Region Area',
        statusDrawing: 'Drawing',
        statusEditing: 'Editing',
        statusDrawn: 'Drawn',
        statusNotDrawn: 'Not Drawn',
        tipDrawing: 'Click on the map to add vertices, then click "Finish"',
        tipLoaded: 'Saved region loaded. Click "Edit Region" to modify',
        tipAdded: '{n} vertices added. Keep clicking to add more',
        tipFinished: 'Drawing finished. Click "Save Region Area" to save',
        tipEditing: 'Edit mode: drag vertices to adjust the polygon',
        tipExitedEdit: 'Exited edit mode',
        finishCurrent: 'Finish Current Region',
        newRegion: 'New Region',
        clearAll: 'Clear All Regions',
        regionLabel: 'Region {n}',
        tipRestored: 'Original region restored'
      },
      msg: {
        loadFail: 'Failed to load data, please try again later',
        addSuccess: 'Added successfully',
        addFail: 'Failed to add',
        editSuccess: 'Updated successfully',
        editFail: 'Failed to update',
        deleteSuccess: 'Deleted successfully',
        deleteFail: 'Failed to delete, please try again later',
        deleteConfirm: 'Are you sure you want to delete region {name}?',
        tip: 'Tip',
        confirmDelete: 'Delete',
        cancel: 'Cancel',
        drawMinPoints: 'At least 3 points are required to form a polygon',
        drawFinished: 'Drawing finished, {n} vertices in total',
        drawFirst: 'Please draw the region area first',
        drawFirstMin: 'Please draw the region area first (at least 3 points)',
        clearConfirm: 'Are you sure to clear the current region area?',
        confirmClear: 'Clear',
        cleared: 'Current drawing cleared. You can redraw now',
        saved: 'Region area saved',
        saveFail: 'Failed to save, please try again later',
        exportEmpty: 'The table is empty, nothing to export',
        exportSuccess: 'Exported successfully',
        exportFail: 'Export failed, please try again',
        removeRegionConfirm: 'Are you sure to delete this region?',
        finishCurrentFirst: 'Please finish the current region first',
        cross180NotSupported: 'Crossing the 180° meridian is not supported. Please draw in segments.',
        scriptNotLoaded: 'Map script not loaded, please try again later'
      },
      validate: {
        plCodeRequired: 'Please enter region code',
        plCodeMax: 'Region code cannot exceed 50 characters',
        plNameRequired: 'Please enter region name',
        plNameMax: 'Region name cannot exceed 100 characters',
        rangeRequired: 'Please enter time range',
        rangeBetween: 'Time range must be between 0 and 365',
        onRangeRequired: 'Please choose whether to show predictions that have not occurred within the range',
        outRangeRequired: 'Please choose whether to show predictions that have not occurred outside the range'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/modules/plate.js